import { Files } from '../StrokeIcons';

type CreateDocumentRowProps = {
  onCreate: () => void;
};

/** The "Create new document" row at the bottom of TipTapInput's `/` document dropdown. */
export const CreateDocumentRow = ({ onCreate }: CreateDocumentRowProps) => (
  <div
    onMouseDown={(e) => {
      // mousedown, not click: keep focus (and the open suggestion) in the editor.
      e.preventDefault();
      onCreate();
    }}
    className="px-3 py-2 flex items-center gap-3 text-sm cursor-pointer border-t border-slate-200 dark:border-charade-700 hover:bg-slate-100 dark:hover:bg-charade-900 text-astronaut-600 dark:text-astronaut-400">
    <div className="w-12 h-8 rounded-sm border border-dashed border-astronaut-400 dark:border-astronaut-600 bg-astronaut-50 dark:bg-astronaut-900/20 shrink-0 flex items-center justify-center">
      <Files.FilePlus02 className="size-4" />
    </div>
    <span>Create new document</span>
  </div>
);
